import { AxiosRequestConfig } from "axios";

const baseUrl: string = process.env.NEXT_PUBLIC_BASE_URL as string;

const LandingPageServices = {
  getBanner: (): AxiosRequestConfig => ({
    url: `${baseUrl}/mytens-explore/v3/banner`,
    method: "GET",
    headers: {
      Authorization: `Basic ${process.env.NEXT_PUBLIC_BASIC_AUTH}`,
    },
  }),
  getTestimony: (): AxiosRequestConfig => ({
    url: `${baseUrl}/mytens-explore/v4/testimony`,
    method: "GET",
    headers: {
      Authorization: `Basic ${process.env.NEXT_PUBLIC_BASIC_AUTH}`,
    },
  }),
  getBackgroundLead: (): AxiosRequestConfig => ({
    url: `${baseUrl}/mytens-explore/v3/background-lead`,
    method: "GET",
    headers: {
      Authorization: `Basic ${process.env.NEXT_PUBLIC_BASIC_AUTH}`,
    },
  }),
};

export default LandingPageServices;
